import { produce } from 'immer';

import * as actions from './actions';

export default produce((state, action) => {
  switch (action.type) {

  case actions.ADD_PLAN:
    state.unshift(action.plan);
    break;

  case actions.SET_PLAN:
    return state.map(plan => plan.id === action.plan.id ? action.plan : plan);

  case actions.CHANGE_PLAN:
    return state.map((plan) => {
      if (plan.id === action.plan.id) {
        plan = { ...plan, ...action.changes };
      }

      return plan;
    });

  case actions.REMOVE_PLAN:
    return state.filter(plan => plan.id !== action.plan.id);
  }
}, []);
